import { featuredVideos, featuredShorts, socials } from '../data/siteData'
import ScrollReveal from './ScrollReveal'
import './VideoSection.css'

const isPlaceholder = (id) => id.startsWith('REPLACE_WITH')

export default function VideoSection() {
  return (
    <div className="video-section">
      <div className="video-block">
        <h3 className="video-block-title">Event Highlights</h3>
        <div className="video-grid">
          {featuredVideos.map((v, i) => (
            <ScrollReveal as="div" key={v.id + i} delay={i * 100} className="video-card">
              {isPlaceholder(v.id) ? (
                <a
                  href={socials.youtube}
                  target="_blank"
                  rel="noreferrer"
                  className="video-placeholder"
                  >
                  <span className="video-play">&#9658;</span>
                  <span className="video-placeholder-text">
                    Watch on YouTube
                    <small>Add your video ID in siteData.js to embed it here</small>
                  </span>
                </a>
              ) : (
                <iframe
                  src={`https://www.youtube-nocookie.com/embed/${v.id}`}
                  title={v.title}
                  loading="lazy"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              )}
              <p className="video-caption">{v.title}</p>
            </ScrollReveal>
          ))}
        </div>
      </div>

      <div className="video-block">
        <h3 className="video-block-title">Shorts</h3>
        <div className="shorts-grid">
          {featuredShorts.map((s, i) => (
            <ScrollReveal as="div" key={s.id + i} delay={i * 90} className="short-card">
              {isPlaceholder(s.id) ? (
                <a
                  href={socials.instagram}
                  target="_blank"
                  rel="noreferrer"
                  className="video-placeholder short-placeholder"
                >
                  <span className="video-play">&#9658;</span>
                  <span className="video-placeholder-text">
                    Watch Reel
                    <small>Add a Short ID to embed</small>
                  </span>
                </a>
              ) : (
                <iframe
                  src={`https://www.youtube-nocookie.com/embed/${s.id}`}
                  title={s.title}
                  loading="lazy"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              )}
              <p className="video-caption">{s.title}</p>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </div>
  )
}
